/** Eladói fiók — hirdetés sorrend és jóváhagyás állapot. */

export function isListingPendingApproval(car) {
  return car?.status === "profile";
}

/** Élő elöl, lejárt közép, jóváhagyásra váró hátul. */
export function sortSellerDashboardListings(cars = []) {
  const rank = (c) => {
    if (c.status === "public") return 0;
    if (c.status === "expired") return 1;
    return 2;
  };
  return [...cars].sort((a, b) => {
    const dr = rank(a) - rank(b);
    if (dr !== 0) return dr;
    return (b.created_at || "").localeCompare(a.created_at || "");
  });
}
